import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'
import Classes from './Classes'
import Home from './Home'
import Income from './Income'
import Profile from './Profile'
// import Message from './Message'
import Notification from './Notification'
import UpdateProfile from './UpdateProfile'
import Contracts from './Contracts'
import Policies from './Policies'
import Conversation from './Conversation'
import Request from './Request'

const Dashboard = (store) => ({
  path: ROUTE.HOME,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'dashboard',
    loadReducer: () => import('./DashboardState'),
    loadComponent: () => import('./DashboardContainer'),
  }),
  routes: [
    Home(store),
    Classes(store),
    Income(store),
    Profile(store),
    Notification(store),
    UpdateProfile(store),
    Contracts(store),
    Policies(store),
    Conversation(store),
    Request(store)
  ],
})

export default Dashboard
